module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Thunder-1d2aabd6b0d61dd3a446bfd2730ff9af.svg";